import { OptionSet } from './OptionSet.jsx'
import { FreeText } from './FreeText.jsx'

/**
 * kind: binary_plus_text — the binary control plus an optional box.
 *
 * The box is always visible rather than appearing after "yes". Showing it
 * conditionally would be a branching rule, and no branching rule exists in the
 * item data.
 */
export function BinaryPlusText(props) {
  return (
    <div>
      <OptionSet {...props} />
      <FreeText {...props} />
    </div>
  )
}
